module.exports = __webpack_public_path__ + "static/media/download-doc.1b210136.svg";